export default __webpack_public_path__ + "static/media/cart.cb6a4dda.svg";